import Block from '../../common.blocks/block'

export default class InfiniteScroll extends Block {
	static title = 'infinite-scroll'

	constructor($el) {
		super($el)

		this.button = this.$el.findElement('button')
		this.total = this.$el.findElement('total')
		this.spinner = this.$el.findElement('spinner')
		this.progressBar = this.$el.findElement('progress').find('span')

		this.overviewContainer = $('.product-overview')

		this.index = 2
		this.loading = false
		this.offset = 700

		this.bottom =
			this.overviewContainer.position().top +
			this.overviewContainer.height() -
			this.offset

		this.infiniteScrollListener = () => this.handleEvent()
		window.addEventListener('scroll', this.infiniteScrollListener, {
			passive: true,
		})

		this.button.on('click', () => {
			this.handleEvent()
		})
	}

	handleEvent() {
		if (this.loading || $(window).scrollTop() < this.bottom) {
			return null
		}

		this.loading = true
		this.setLoading(true)

		const data = new FormData()
		data.append('ajax', true)
		data.append('infinite', true)
		data.append('index', this.index)

		$.ajax({
			method: 'POST',
			processData: false,
			contentType: false,
			cache: false,
			url: window.location.href,
			data: data,
		})
			.done((json) => {
				const container = $(this.$el.data('container'))
				container.append(json.html)
				this.total.html(json.limit)
				this.progressBar.css('width', json.percentage + '%')
				this.index++

				if (json.limit >= json.total) {
					window.removeEventListener('scroll', this.infiniteScrollListener, {
						passive: true,
					})

					this.loading = false
					this.setLoading(false)
					this.button.prop('disabled', true)
					return
				}

				this.bottom =
					this.overviewContainer.position().top +
					this.overviewContainer.height() -
					this.offset

				setTimeout(() => {
					this.loading = false
				}, 3000)
				this.setLoading(false)
			})
			.fail((error) => {
				$(document).trigger('message:error', { message: error.message })

				this.loading = false
				this.setLoading(false)
			})
	}

	setLoading(bool) {
		if (bool) {
			this.spinner.addClass('infinite-scroll__spinner--active')
			this.button.prop('disabled', true)
		} else {
			this.spinner.removeClass('infinite-scroll__spinner--active')
			this.button.prop('disabled', false)
		}
	}
}
